import { getState } from "../state";

const d3 = require('d3');

function zoomToPath(id) {
  const path = document.getElementById(id);
  if (!path) return false;
  [...document.querySelectorAll('#stores path')].forEach(e => e.classList.remove('is-active'));
  path.classList.add('is-active');
  const { zoom, svg } = window;
  const svgNode = svg._groups[0][0];
  const width = Number(svgNode.getAttribute('width'));
  const height = Number(svgNode.getAttribute('height'));
  const mapId = document.querySelector('.map-container > svg > g').id;

  const parentBbox = {
    'map-IV': {
      x: -180,
      y: -150,
    },
    'map-III': {
      x: -180,
      y: -150,
    },
    'map-II': {
      x: -180,
      y: -150,
    },
    'map-I': {
      x: -180,
      y: -150,
    },
  };
  const bbox = path.getBBox();

  const x = bbox.x + (bbox.width / 2) + parentBbox[mapId].x;
  const y = bbox.y + (bbox.height / 2) + parentBbox[mapId].y;
  const scale = 10;
  const translate = [width / 2 - scale * x, height / 2 - scale * y];

  svg.transition()
    .duration(750)
    .call(zoom.transform, d3.zoomIdentity.translate(translate[0],translate[1]).scale(scale));
}

export default zoomToPath;



// WEBPACK FOOTER //
// ./resources/assets/js/components/map/utlis/zoomToPath.js